<template>
  <button class="video-play">
    <img
      class="video-play__icon"
      src="~@/assets/images/videos/play.png"
      alt=""
    />
  </button>
</template>

<script>
export default {
  name: "VideoPlay"
};
</script>

<style lang="scss">
$p: ".video-play";

.video-play {
  background-color: colors(palette-10);
  border-radius: 50%;
  width: 75px;
  height: 75px;
  outline: none;

  &:focus {
    box-shadow: 0 0 0 2px #5e9ed6;
  }

  &__icon {
    transition: transform 0.3s;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-42%, -50%);
  }

  &:hover {
    #{$p}__icon {
      transform: translate(-42%, -50%) scale(1.1);
    }
  }

  &:active {
    #{$p}__icon {
      transform: translate(-42%, -50%) scale(0.9);
    }
  }
}
</style>
